module.exports = __webpack_public_path__ + "assets/img/b294-ad.svg";